import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { CoreUtils, ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import commonMessages from '~/core/commonMessages';
import { PlayoffSeriesInfo } from '~/core/types';
import { FormatPlayoffSeriesInfo } from '~/core/utils';
import GameOrSeriesScoreboard from '~/views/components/gameOrSeriesScoreboard/GameOrSeriesScoreboard';
import { GameCenterOrPlayoffSeriesTeam } from '~/views/components/gameOrSeriesScoreboard/types';

import { PlayoffSeries } from '../../types';

import { BannerLogo, RoundAndSeriesMessage, ScoreboardContentContainer, SeriesStatusMessage } from './styles';

type PlayoffSeriesScoreboardProps = {
    series: PlayoffSeries;
    year: string;
};

const PlayoffSeriesScoreboard: FC<PlayoffSeriesScoreboardProps> = ({ series, year }) => {
    const intl = useIntl();

    const { bottomSeedTeam, neededToWin, roundAbbrev, seriesLogo, seriesLogoFr, topSeedTeam } = series;

    const seriesHasNoCompleteGames = !CoreUtils.isPostGame(series.games[0]?.gameState);

    const getChildren = () => {
        const playoffSeriesInfo: PlayoffSeriesInfo = {
            topSeedAbbrev: topSeedTeam.abbrev,
            topSeedWins: topSeedTeam.seriesWins,
            bottomSeedAbbrev: bottomSeedTeam.abbrev,
            bottomSeedWins: bottomSeedTeam.seriesWins,
            neededToWin: neededToWin,
        };

        let bannerLogo: string | undefined = seriesLogo;

        if (intl.locale === ShortCodeEnums.Language.French && seriesLogoFr !== undefined) {
            bannerLogo = seriesLogoFr;
        }

        return (
            <ScoreboardContentContainer>
                {!!bannerLogo && <BannerLogo src={bannerLogo} />}
                <RoundAndSeriesMessage>
                    {!bannerLogo && <>{year}&nbsp;</>}
                    <CoreUtils.SafeFormattedMessage
                        message={commonMessages.playoffRoundDescriptions.long[roundAbbrev]}
                    />
                    {!seriesHasNoCompleteGames && (
                        <SeriesStatusMessage>
                            <FormatPlayoffSeriesInfo playoffSeriesInfo={playoffSeriesInfo} />
                        </SeriesStatusMessage>
                    )}
                </RoundAndSeriesMessage>
            </ScoreboardContentContainer>
        );
    };

    return (
        <GameOrSeriesScoreboard
            isSeries
            leftTeam={bottomSeedTeam as GameCenterOrPlayoffSeriesTeam}
            rightTeam={topSeedTeam as GameCenterOrPlayoffSeriesTeam}
            hideRecord
        >
            {getChildren()}
        </GameOrSeriesScoreboard>
    );
};

export default PlayoffSeriesScoreboard;
